import AttachmentIcon from "@mui/icons-material/Attachment"
import OpenLinkIcon from "@mui/icons-material/OpenInNew"
import { Box } from "@mui/material"
import Card from "@mui/material/Card"
import CardActionArea from "@mui/material/CardActionArea"
import CardContent from "@mui/material/CardContent"
import Typography from "@mui/material/Typography"
import { makeStyles } from "tss-react/mui-compat"

interface AttachmentCardProps {
  name: string
  description: string
  type: "link" | "file"
  onClick: React.MouseEventHandler<HTMLButtonElement>
}

const useStyles = makeStyles()({
  cardContainer: {
    minWidth: 250,
    width: 250,
    minHeight: 163,
    margin: "0 18px 20px 2px",
    "&.MuiPaper-rounded": {
      borderRadius: "10px",
    },
  },
  actionContainer: {
    height: "100%",
  },
  headerContainer: {
    display: "flex",
  },
  contentContainer: {
    height: "100%",
  },
  name: {
    flex: 1,
    fontSize: 20,
    marginRight: 16,
    marginBottom: 10,
  },
});

const AttachmentCard = (props: AttachmentCardProps) => {
  const { name, description, type, onClick } = props
  const { classes } = useStyles()

  return (
    <Card className={classes.cardContainer} elevation={3}>
      <CardActionArea className={classes.actionContainer} onClick={onClick}>
        <CardContent className={classes.contentContainer}>
          <Box className={classes.headerContainer}>
            <Typography variant="h3" className={classes.name} gutterBottom>
              {name}
            </Typography>
            {type === "link" ? <OpenLinkIcon /> : <AttachmentIcon />}
          </Box>
          <Typography>{description}</Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  )
}

export default AttachmentCard
